
import React, { } from 'react';
import './navigationMenu.css';
import Header from './../header/header';
import Menu from './../menu/menu';



const NavigationMenu = ({ children, isHeaght }) => {

  return (
    <>
      <Header />
      <div className="container_navigation_menu">
        <div>
          <Menu />
        </div>
        <div className={isHeaght ? 'children_content' : ' children_content_revers'}>
          {children}
        </div>

      </div>

    </>

  )
}

export default NavigationMenu;